import { render, staticRenderFns } from "./SignupNav.vue?vue&type=template&id=ffdb9fd4&"
import script from "./SignupNav.vue?vue&type=script&lang=js&"
export * from "./SignupNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports